import React from 'react';
import dayjs from 'dayjs';
import { Col, DatePicker, Form, Row, Button } from 'antd';

const SearchCriteria: React.FC<any> = ({ form, onSearchClick }) => {
    return (
        <>
            <Form layout='horizontal' form={form} onFinish = {onSearchClick}>
                <Row gutter={24}>
                    <Col>
                        <Form.Item label='Date' name='date' rules={[{ required: true, message: 'Please select the date!' }]} initialValue={dayjs()}>
                        <DatePicker/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={24} style={{ textAlign: 'right' }}>
                        <Button style={{ width: '80px' }} type="primary" htmlType="submit">
                            Search
                        </Button>
                    </Col>
                </Row>
            </Form>
        </>
    )
}



export default SearchCriteria